import React, { useEffect } from 'react';
import SpeakerBanner from './SpeakerBanner';

// This component renders only the speaker banner without any app layout
const SpeakerBannerOnly: React.FC = () => {
  useEffect(() => {
    // Hide navigation and other elements when this component mounts
    const nav = document.querySelector('nav');
    const body = document.body;
    const appContainer = document.querySelector('.min-h-screen.bg-gray-50');
    
    if (nav) nav.style.display = 'none';
    if (appContainer) (appContainer as HTMLElement).style.background = '#f3f4f6';
    body.style.margin = '0';
    body.style.padding = '0';
    body.style.background = '#f3f4f6';
    
    // Cleanup function to restore navigation when component unmounts
    return () => {
      if (nav) nav.style.display = '';
      if (appContainer) (appContainer as HTMLElement).style.background = '';
      body.style.margin = '';
      body.style.padding = '';
      body.style.background = '';
    };
  }, []);

  return (
    <div style={{ 
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      background: '#f3f4f6',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999
    }}>
      <SpeakerBanner />
    </div>
  );
};

export default SpeakerBannerOnly;
